// https://www.bankgirot.se/globalassets/dokument/anvandarmanualer/bankernaskontonummeruppbyggnad_anvandarmanual_sv.pdf
var BANKS = [{
  name: 'Amfa Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^966[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Avanza Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^95[5-6][0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'BlueStep Finans',
  type: 1,
  comment: 1,
  clearingRegex: /^968[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'BNP Paribas SA.',
  type: 1,
  comment: 2,
  clearingRegex: /^947[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Citibank',
  type: 1,
  comment: 2,
  clearingRegex: /^904[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Danske Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^(12|13|24)[0-9]{2}/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'DNB Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^(919|926)[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Ekobanken',
  type: 1,
  comment: 2,
  clearingRegex: /^970[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Erik Penser',
  type: 1,
  comment: 2,
  clearingRegex: /^959[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Forex Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^94[0-4][0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'ICA Banken',
  type: 1,
  comment: 1,
  clearingRegex: /^927[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'IKANO Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^917[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'JAK Medlemsbank',
  type: 1,
  comment: 2,
  clearingRegex: /^967[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Klarna',
  type: 1,
  comment: 2,
  clearingRegex: /^978[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Landshypotek',
  type: 1,
  comment: 2,
  clearingRegex: /^939[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Lunar Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^971[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Lån & Spar Bank Sverige',
  type: 1,
  comment: 1,
  clearingRegex: /^963[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Länsförsäkringar Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^(340|906)[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Länsförsäkringar Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^902[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Marginalen Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^923[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Multitude Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^907[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'MedMera Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^965[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Nordax Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^964[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Nordea',
  type: 1,
  comment: 1,
  clearingRegex: /^(?!3300|3782)(1[1456789][0-9]{2}|20[0-9]{2}|3[0-3][0-9]{2}|34[1-9][0-9]|3[5-9][0-9]{2})/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Nordea',
  type: 1,
  comment: 2,
  clearingRegex: /^4[0-9]{3}/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Nordea',
  type: 2,
  comment: 3,
  clearingRegex: /^(95[0-4][0-9]|996[0-9])/.source,
  regex: /[0-9]{10}$/.source
}, {
  name: 'Nordea',
  type: 2,
  comment: 1,
  clearingRegex: /^(3300|3782)/.source,
  regex: /[0-9]{10}$/.source
}, {
  name: 'Nordnet Bank',
  type: 1,
  comment: 2,
  clearingRegex: /^910[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Resurs Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^928[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Riksgälden',
  type: 1,
  comment: 2,
  clearingRegex: /^988[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Santander Consumer Bank',
  type: 1,
  comment: 1,
  clearingRegex: /^946[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'SBAB',
  type: 1,
  comment: 1,
  clearingRegex: /^925[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'SEB',
  type: 1,
  comment: 1,
  clearingRegex: /^(5[0-9]{3}|912[0-4]|91[3-4][0-9])/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Skandiabanken',
  type: 1,
  comment: 2,
  clearingRegex: /^91[5-6][0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Svea',
  type: 1,
  comment: 2,
  clearingRegex: /^966[0-9]/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Swedbank',
  type: 1,
  comment: 1,
  clearingRegex: /^7[0-9]{3}/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Ålandsbanken',
  type: 1,
  comment: 2,
  clearingRegex: /^23[0-9]{2}/.source,
  regex: /[0-9]{7}$/.source
}, {
  name: 'Danske Bank',
  type: 2,
  comment: 1,
  clearingRegex: /^918[0-9]/.source,
  regex: /[0-9]{10}$/.source
}, {
  name: 'Handelsbanken',
  type: 2,
  comment: 2,
  clearingRegex: /^6[0-9]{3}/.source,
  regex: /[0-9]{9}$/.source
}, {
  name: 'Nordea Plusgirot',
  type: 2,
  comment: 3,
  clearingRegex: /^(95[0-4][0-9]|996[0-9])/.source,
  regex: /[0-9]{10}$/.source
}, {
  name: 'Riksgälden',
  type: 2,
  comment: 1,
  clearingRegex: /^989[0-9]/.source,
  regex: /[0-9]{10}$/.source
}, {
  name: 'Sparbanken Syd',
  type: 2,
  comment: 1,
  clearingRegex: /^957[0-9]/.source,
  regex: /[0-9]{10}$/.source
}, {
  name: 'Swedbank',
  type: 2,
  comment: 3,
  clearingRegex: /^8[0-9]{3}/.source,
  regex: /[0-9]{7,11}$/.source,
  ignoresValidation: true
}, {
  name: 'Swedbank',
  type: 2,
  comment: 1,
  clearingRegex: /^93[0-4][0-9]/.source,
  regex: /[0-9]{10}$/.source
}];
module.exports = BANKS;